import React, { useEffect, useState } from "react";
import { Card, Typography, Button } from "@mui/material";
import { fetchCurrentTimeApi } from "../../../services/service";

export default function ExamCard({
  exam,
  handleClick,
  handleInstructionsClick,
  currentTime
}) {
  const [disabled, setDisabled] = useState(false);
  
  const checkDisabled = async () => {
    if (!exam.start_date || !exam.end_time || !currentTime) return false;

      const [year, month, day] = exam.start_date.split("-").map(Number);
      const [hours, minutes, seconds] = exam.end_time.split(":").map(Number);

      const endDateTime = new Date(
        year,
        month - 1,
        day,
        hours,
        minutes,
        seconds
      );

      return currentTime >= endDateTime; 
  
  };

  useEffect(() => {
    const fetchAndSet = async () => {
      const result = await checkDisabled();
      setDisabled(result);
    };

    fetchAndSet();

    // const interval = setInterval(fetchAndSet, 60000);
    // return () => clearInterval(interval);
  }, [currentTime]);

// useEffect(() => {
//   fetchCurrentTime()
// }, [])



  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: 3,
        p: 1,
        maxWidth: "100%",
        mb: 2,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <Typography style={{ paddingLeft: "16px" }} variant="h5" gutterBottom>
            <strong>{exam.exam_name}</strong>
          </Typography>
          <div style={{ paddingLeft: "16px", display: "flex", gap: "20px" }}>
            <Typography style={{ fontSize: "15px" }}>
              <span>Start Date:</span> {exam.start_date}
            </Typography>
            <Typography style={{ fontSize: "15px" }}>
              <span>Start Time:</span> {exam.start_time}
            </Typography>
            <Typography style={{ fontSize: "15px" }}>
              <span>Duration:</span> {exam.duration} minutes
            </Typography>
          </div>
        </div>
        <div
          style={{
            paddingRight: "16px",
            display: "flex",
            gap: "10px",
            flexDirection: "column",
            justifyContent: "center",
            height: "100px",
          }}
        >
          {exam.status === "submitted" ? (
            <Typography style={{ color: "green", fontWeight: 600 }}>
              Completed
            </Typography>
          ) : (
            <>
              <Button
                variant="contained"
                disabled={disabled}
                onClick={(event) =>
                  handleClick(
                    event,
                    exam.id,
                    exam.start_date,
                    exam.start_time,
                    exam.exam_pin
                  )
                }
              >
                {exam.status === "resume" ? "Resume" : "Start"}
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={() => handleInstructionsClick(exam.id)}
              >
                Instructions
              </Button>
            </>
          )}
        </div>
      </div>
    </Card>
  );
}
